// MA-852 (D-PUX-1): /parent/kids — the Kids tab (/parent/settings/kids and
// /profiles redirect here). MA-858 (§4 Kids): SettingsKids renders one card
// per kid; the h1 below is the page's one "Kids" heading.
import { createFileRoute } from "@tanstack/react-router";
import { SettingsKids } from "@/screens/ParentSettingsSections";
import { ParentRouteError } from "@/components/RouterErrorFallback";

function ParentKidsPage() {
  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col bg-cream" data-testid="parent-kids-page">
      <header className="px-6 pb-1 pt-4">
        <h1 className="font-serif text-xl font-semibold">Kids</h1>
      </header>
      <div className="px-6 pb-10">
        <SettingsKids />
      </div>
    </div>
  );
}

export const Route = createFileRoute("/parent/kids")({
  errorComponent: ParentRouteError,
  head: () => ({ meta: [{ title: "PencilWise · Kids" }] }),
  component: ParentKidsPage,
});
